/**
 * Update WEB_PRIVATE_FLAG_NAMES and WEB_PUBLIC_FLAG_NAMES items in the config table
 * for each environment when adding or removing new flags.
 */

export const FeatureFlagEnum = {
  acuityOverride: "TEMPORARY_ACUITY_OVERRIDE",
  insuranceEligibilityCheck: "OPERATIONAL_CHECK_INSURANCE_ELIGIBILITY_FLAG",
  manualPaymentProcessing: "OPERATIONAL_MANUAL_PAYMENT_PROCESSING",
  recaptchaOverride: "OPERATIONAL_OVERRIDE_RECAPTCHA",
  restrictPatientScheduling: "OPERATIONAL_RESTRICT_PATIENT_SCHEDULING",
  updatedCalendarNps: "UPDATED_CALENDAR_NPS", // operational
} as const;

export const FLAGS_WITH_RULES = ["SCHEDULING_CALENDAR_V2", "ENABLED_CARRIER_PAYWALL"];
